// extracted by mini-css-extract-plugin
export var md = "_31-4";
export var semantic = "_31-5";
export var sm = "_31-3";
export var text = "_31-6";
export var toggleInput = "_31-0";
export var toggleSwitch = "_31-1";
export var xs = "_31-2";